module.exports = __webpack_public_path__ + "img/Trophy.be48347d.svg";